import { z } from 'zod';

/** One audit-log record. before/after/meta are parsed JSON (or null). */
export interface AuditEntry {
  id: string;
  at: string; // ISO-8601 UTC
  actorUserId: string | null;
  actorRole: string | null;
  action: string; // e.g. 'rbac.override.set', 'case.advance_stage'
  entityType: string; // e.g. 'role', 'case'
  entityId: string | null;
  before: unknown;
  after: unknown;
  ip: string | null;
  meta: unknown;
}

export const auditQuerySchema = z.object({
  entityType: z.string().optional(),
  entityId: z.string().optional(),
  action: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});
export type AuditQuery = z.infer<typeof auditQuerySchema>;

export interface AuditListResponse {
  entries: AuditEntry[];
  limit: number;
  offset: number;
}
